import React from 'react'
import _ from 'lodash'
import Tray from '../Tray/Video'
import { onUserAuth } from '../../redux/user/helpers'
import { fetchHistory } from '../../redux/uservideo/helpers'

import './style.css'

class ContinueWatching extends React.Component {
  constructor(props) {
    super(props)
    this.state = { records: null }
  }

  render() {
    return (
      <div className={ `continue-watching ${this.state.records ? '' : 'empty'}` }>
        {!_.isEmpty(this.state.records) && (
          <Tray
            layout={ this.props.layout }
            data={ {
              contentData: this.state.records.map(x => x.contentResponse),
              title: 'Continue Watching',
              filter: 'Watch History',
              ...(this.state.records.length >= 20 && { 
                categoryUrl: '/user/history', 
                settings: { seeAllPermalink: true }
              })
            } } />
        ) }
      </div>
    )
  }

  componentDidMount() {
    onUserAuth(user => {
      if (!user)
        return this.setState({...this.state, records: null })

      fetchHistory(user.userId).then(r => {
        this.setState({...this.state, records: r })
      })
    })
  }
}


export default ContinueWatching;
